/**
 * D'où vient la désinscription d'une adresse des e-mails et SMS d'Alertis — la
 * colonne `source` du registre des désinscrits, dite en clair. Sans origine :
 * le lien de désabonnement en bas d'un e-mail, qui n'en enregistre pas.
 */
const ORIGINES_DESINSCRIPTION = {
  back_office: 'Marqué depuis le back-office',
  commercial: '« Ne pas relancer » posé sur une demande',
  formateur_desinscription: 'Lien « Me désinscrire » d’un rappel d’inscription',
}

export function origineDesinscription(origine) {
  return ORIGINES_DESINSCRIPTION[origine] || 'Lien de désabonnement d’un e-mail'
}
